<template>
  <div class="c-lookup-empty">
    <h2 class="c-lookup-empty__term">{{ term }}</h2>
    <p v-if='lookupLoaded' class="c-lookup-empty__text">{{ $t('LOOKUP_NO_CONTENT') }}</p>
    <p v-else class="c-lookup-empty__text">{{ $t('LOOKUP_LOADING') }}</p>
  </div>
</template>

<script>
export default {
  name: 'LookupEmpty',

  props: {
    term: {
      type: String,
      default: ''
    },
    lookupLoaded: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.c-lookup-empty {
  padding: 4em 2rem;
  font-size: 1rem;
  text-align: center;
}

.c-lookup-empty__term {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: .8rem;
}

.c-lookup-empty__text {
  text-transform: initial;
}
</style>
